export { default as NotReferringView } from './NotReferringView';
